import { render, staticRenderFns } from "./ItemEditorTestArgument.vue?vue&type=template&id=17265f8e&"
import script from "./ItemEditorTestArgument.vue?vue&type=script&lang=ts&"
export * from "./ItemEditorTestArgument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports